/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  QuizletResultsResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get personalized results for the quizlet v2 questionnaire.

Returns personalized messages based on the user's quiz answers.
- For members: includes firstName for personalization
- For anonymous sessions: no firstName, but still gets personalized messages

The personalizedMessages are returned in Sanity portable text format
for rich content rendering on the frontend.
 * @summary Get Quizlet Results
 */
export const getQuizletResultsV2QuizletResultsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<QuizletResultsResponse>(
      {url: `/v2/quizlet/results`, method: 'GET', signal
    },
      );
    }
  

export const getGetQuizletResultsV2QuizletResultsGetQueryKey = () => {
    return [`/v2/quizlet/results`] as const;
    }

    
export const getGetQuizletResultsV2QuizletResultsGetQueryOptions = <TData = Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuizletResultsV2QuizletResultsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>> = ({ signal }) => getQuizletResultsV2QuizletResultsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetQuizletResultsV2QuizletResultsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>>
export type GetQuizletResultsV2QuizletResultsGetQueryError = unknown


export function useGetQuizletResultsV2QuizletResultsGet<TData = Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>,
          TError,
          Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuizletResultsV2QuizletResultsGet<TData = Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>,
          TError,
          Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuizletResultsV2QuizletResultsGet<TData = Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Quizlet Results
 */

export function useGetQuizletResultsV2QuizletResultsGet<TData = Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizletResultsV2QuizletResultsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetQuizletResultsV2QuizletResultsGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



